module.exports = __webpack_public_path__ + "img/integrasi_api.abd84f35.svg";